import type { ReactElement } from 'react'

interface HeroCraneProps {
  size?: number
}

/**
 * HeroCrane — a large photographic-style origami crane image.
 * Used on title and end-of-match screens. Place hero-crane.png at
 * /glyph-assets/hero-crane.png in the client's public directory.
 */
export const HeroCrane = ({ size = 460 }: HeroCraneProps): ReactElement => (
  <img
    src="/glyph-assets/hero-crane.png"
    alt="origami crane"
    width={size}
    height={size}
    style={{
      display: 'block',
      filter: 'drop-shadow(4px 8px 0 rgba(42,34,26,0.18))',
    }}
  />
)
